import { render, staticRenderFns } from "./LOL.vue?vue&type=template&id=5b523444&scoped=true&"
import script from "./LOL.vue?vue&type=script&lang=ts&"
export * from "./LOL.vue?vue&type=script&lang=ts&"
import style0 from "./LOL.vue?vue&type=style&index=0&id=5b523444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b523444",
  null
  
)

export default component.exports